﻿export const navigationMenuState = function ({
	settings,
}) {
	return {
		settings,
		searchString: '',
		showSpinner: false,
		showResults: false,
		showSearch: false,
		showError: false,
		results: {},
		spinnerStartTime: Date.now(),

		setupComponent: function () {
		},
		
		//type ahead stuff
		search: async function (goToPage) {
			if (this.searchString &&
				this.searchString.length >= this.settings.Typeahead.MinimumLength &&
				this.searchString.length <= this.settings.Typeahead.MaximumLength) {

				this.showError = false;

				var url = `${this.settings.Typeahead.BaseUrl}?handler=typeaheadresults&searchString=${this.searchString}`;

				var payload;
				try {
					this.showSpinner = true;
					this.spinnerStartTime = Date.now();
					await $.ajax({
						type: 'GET',
						url: url,
						success: function (response) {
							payload = response;
						}
					});
				} catch (error) {
					console.log(error);
				}

				if (payload) {
					this.handlePayload(payload, goToPage);
				} else {
					this.showError = true;
					this.showSpinner = false;
				}

			} else {
				this.results = {};
				this.showResults = false;
			}
		},

		handlePayload: function (payload, goToPage) {
			this.results = this.getResults(payload);

			if (goToPage) {
				if (this.results.length == 1 && this.results[0].Products.length == 1) {
					window.location.href = this.results[0].Products[0].url;
				} else {
					window.location.href = `${this.settings.Typeahead.BaseUrl}/ALL/${this.searchString}`;
				}
			} else {
				this.displayResults();
			}


		},

		getResults: function (payload) {
			var map = {};

			payload.SearchResults.forEach(function (item) {

				var displayValue = item.ProductTypeCodeDisplay;

				if (!map[displayValue]) {
					map[displayValue] = { ProductCategory: displayValue, ProductTypeCode: item.ProductTypeCode, Products: [this.getProduct(item)] };
					return;
				}

				map[displayValue].Products.push(this.getProduct(item));

			}, this);

			var result = Object.values(map);

			result.forEach(function (category) {
				if (category.Products.length > this.settings.Typeahead.MaxResultsPerCategory) {
					var overflowProduct = this.getProductOverflow(payload.ProductOverflowTemplate,category.ProductTypeCode, category.Products.length);
					category.Products.length = 0;
					category.Products.push(overflowProduct);
				}
			}, this);

			if (result.length > 1) {
				var allCategory = { ProductCategory: '', ProductTypeCode: '', Products: [] }; 
				allCategory.Products.push(this.getAllProducts(payload.AllResultsText));
				result.push(allCategory)
			}

			return result;
		},

		displayResults: function () {
			const spinnerDuration = 2500; // Minimum duration the spinner should be visible (in milliseconds)
			const elapsedTime = Date.now() - this.spinnerStartTime;
			const remainingTime = spinnerDuration - elapsedTime;

			setTimeout(() => {
				this.showSpinner = false;
			}, remainingTime > 0 ? remainingTime : 0);
			
			this.showResults = true;
		},

		hideSearchResults: function () {
			this.showResults = false;
			this.showSearch = false;
			this.showSpinner = false;
			this.results = {};
			this.searchString = '';
		},

		getProduct: function (item) {
			var displayText = this.getDisplayNameForProduct(item);
			return { displayText: displayText, url: this.getUrlForProduct(item) };
		},

		getUrlForProduct: function (item) {
			return item.ProductUrl;
		},

		getDisplayNameForProduct: function (item) {
			return item.DisplayName;
		},
		getProductOverflow: function (template, productTypeCode, count) {
			var displayText = template.replace("{0}", count);
			return { displayText: displayText, url: this.getUrlForProductOverflow(productTypeCode) };
		},

		getUrlForProductOverflow: function (productTypeCode) {
			return `${this.settings.Typeahead.BaseUrl}/${productTypeCode}/${this.searchString}`;
		},

		getAllProducts: function (template) {
			return { displayText: template, url: `${this.settings.Typeahead.BaseUrl}/ALL/${this.searchString}` };
		},
	}
}